<template>
  <div>
    <div v-if="params.value == 0">0</div>
    <div
      v-else
      @click="showQuantityOnHand()"
      class="text-blue-500 underline cursor-pointer"
    >
      {{ params.value }}
    </div>
  </div>
</template>

<script>
import { ModalBus } from "@/eventBus.js";
import QuantityOnHand from "./modals/QuantityOnHand.vue";

export default {
  name: "QuantityOnHandLink",
  methods: {
    showQuantityOnHand() {
      ModalBus.$emit("open", {
        component: QuantityOnHand,
        closeOnOutsideClick: true,
        props: {
          sku: this.params.data.LocalSKU
        }
      });
    }
  }
};
</script>
